import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {AvailableFetchStatusOperators} from '@em/data-feed/util-types';
import {EmSelectOperandModule} from '@em/shared/mapping-engine/feature';
import {EmInputModule, EmSelectModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-fetch-status-filter',
  templateUrl: './fetch-status-filter.component.html',
  styleUrls: ['./fetch-status-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    EmSelectModule,
    EmInputModule,
    EmSelectOperandModule,
    MatSlideToggleModule,
  ],
})
export class EmFetchStatusFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;

  operators = AvailableFetchStatusOperators;
  valuesList = ['found', 'not_found', 'no_mapping', 'error'];

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
